import {kvpsActiveInactive} from 'src/utilities/utils'
import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {resetResults, byId} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import _ from 'lodash'

let initialState = {
  results: [],
  department: null
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)
getters.byId = byId

getters.allExceptInformationTechnology = (state) => {
  return _.filter(state.results, (department) => department.name !== Constants.DEPARTMENTS.INFORMATION_TECHNOLOGY)
}

getters.kvpsForSelectNoIt = (state) => {
  return kvpsActiveInactive(_.filter(state.results, (department) => department.name !== Constants.DEPARTMENTS.INFORMATION_TECHNOLOGY))
}

getters.kvpsForSelect = (state) => {
  return kvpsActiveInactive(state.results)
}

const mutations = make.mutations(state)
mutations.resetResults = resetResults

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({state}) {
      const response = await ptracGetEntities('departments?sort=name&name.dir=asc')
      if (OK === response.status) {
        state.results = response.data
      }
    },
    async fetchById({}, id) {
      return await ptracGetEntities('departments/' + id)
    }
  }
}
